import { messaging, getToken } from "../firebase";
import { onMessage } from "firebase/messaging";

const vapidKey =
  "BGaq9pEtDrgXbxgt_m33OdqTE4wTsS4SLJbJ12yXu6n6E9brYOn_PMFdFBUf1RJjczrr2BEEMMOnLZ_h9J4YPaQ";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      return null;
    }
    console.log("Notification Permission:", Notification.permission);

    const registration = await navigator.serviceWorker.ready;

    console.log("SW Ready:", registration);

    const token = await getToken(messaging, {
      vapidKey,
    });

    console.log("FCM TOKEN");

    console.log(token);

    return token;
  } catch (err) {
    console.log(err);

    return null;
  }
};

export const foregroundNotification = () => {
  onMessage(messaging, (payload) => {
    console.log(payload);

    alert(payload.notification.title);
  });
};
